import { DOCUMENT } from '@angular/common';
import { Router, NavigationEnd } from '@angular/router';
import {
  Component,
  Inject,
  ElementRef,
  OnInit,
  Renderer2,
  HostListener,
  OnDestroy
} from '@angular/core';
import { ROUTES } from './sidebar-items';
import { AuthService } from 'src/app/service/auth.service';
import { RouteInfo } from './sidebar.metadata';
import { SideMenu } from '../../../models/side-menu.model';
import { MenuService } from '../../../service/menu.service';
import {environment} from '../../../../environments/environment';

declare const Waves: any;
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.sass']
})
export class SidebarComponent implements OnInit, OnDestroy {
  public sidebarItems;
  level1Menu = '';
  level2Menu = '';
  level3Menu = '';
  public innerHeight: any;
  public bodyTag: any;
  listMaxHeight: string;
  listMaxWidth: string;
  headerHeight = 60;
  routerObj = null;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    public elementRef: ElementRef,
    public authService: AuthService,
    public menuService: MenuService,
    private router: Router
  ) {
    this.routerObj = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // logic for select active menu in dropdown
        const currenturl = event.url.split('?')[0];
        this.level1Menu = currenturl.split('/')[1];
        this.level2Menu = currenturl.split('/')[2];

        // close sidebar on mobile screen after menu select
        this.renderer.removeClass(this.document.body, 'overlay-open');
      }
    });
  }

  @HostListener('window:resize', ['$event'])
  windowResizecall(event) {
    this.setMenuHeight();
    this.checkStatuForResize(false);
  }

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.renderer.removeClass(this.document.body, 'overlay-open');
    }
  }
  callLevel1Toggle(event: any, element: any) {
    if (element !== 'integrator') {
      if (element === this.level1Menu) {
        this.level1Menu = '0';
      } else {
        this.level1Menu = element;
      }
      const hasClass = event.target.classList.contains('toggled');
      if (hasClass) {
        this.renderer.removeClass(event.target, 'toggled');
      } else {
        this.renderer.addClass(event.target, 'toggled');
      }
    } else {
      window.open(environment.WEBHB, '_blank');
    }
  }
  callLevel2Toggle(event: any, element: any) {
    if (element === this.level2Menu) {
      this.level2Menu = '0';
    } else {
      this.level2Menu = element;
    }
  }
  callLevel3Toggle(event: any, element: any) {
    if (element === this.level3Menu) {
      this.level3Menu = '0';
    } else {
      this.level3Menu = element;
    }
  }
  ngOnInit() {
    if (this.authService.currentUserValue) {

      // if (this.authService.currentUserValue.usertype.allPermission === true) {
      //   this.sidebarItems = ROUTES.filter((sidebarItem) => sidebarItem);

      // } else {
      const allmenu = new Array<any>();
      this.listToTree(this.authService.currentUserValue.userPermissions
        .filter(elem => elem.permission.isMenu === true && elem.read === true && ['WEB', 'ALL'].includes(elem.permission.deviceType)), undefined, undefined).forEach(d => allmenu.push(d));

      // if (this.authService.currentUserValue.usertype.name !== 'Desenvolvedor') {
      //   const i = allmenu.findIndex(elem => elem.title === 'MENUITEMS.Permissions.List.Permission')
      //   allmenu.splice(i,1);
      // }

      this.sidebarItems = allmenu;


      // this.menuService.get(this.authService.currentUserValue.id).subscribe( result => {
      //   this.sidebarItems = result.data;
      // });
      // }

    }
    this.initLeftSidebar();
    this.bodyTag = this.document.body;
  }
  ngOnDestroy() {
    this.routerObj.unsubscribe();
  }
  initLeftSidebar() {
    const _this = this;
    // Set menu height
    _this.setMenuHeight();
    _this.checkStatuForResize(true);
  }
  setMenuHeight() {
    this.innerHeight = window.innerHeight;
    const height = this.innerHeight - this.headerHeight;
    this.listMaxHeight = height + '';
    this.listMaxWidth = '500px';
  }
  isOpen() {
    return this.bodyTag.classList.contains('overlay-open');
  }
  checkStatuForResize(firstTime) {
    if (window.innerWidth < 1170) {
      this.renderer.addClass(this.document.body, 'ls-closed');
    } else {
      this.renderer.removeClass(this.document.body, 'ls-closed');
    }
  }

  mouseHover(e) {
    const body = this.elementRef.nativeElement.closest('body');

    if (body.classList.contains('submenu-closed')) {
      this.renderer.addClass(this.document.body, 'side-closed-hover');
      this.renderer.removeClass(this.document.body, 'submenu-closed');
    }
  }
  mouseOut(e) {
    const body = this.elementRef.nativeElement.closest('body');

    if (body.classList.contains('side-closed-hover')) {
      this.renderer.removeClass(this.document.body, 'side-closed-hover');
      this.renderer.addClass(this.document.body, 'submenu-closed');
    }
  }

  listToTree(array, parent, tree) {
    // debugger;
    tree = typeof tree !== 'undefined' ? tree : new Array<any>(); // Cabeça da Árvore
    parent = typeof parent !== 'undefined' ? parent : { id: null, name: null, route: null }; // Nodo atual
    const childrenMenu = new Array<any>();



    const children = array.filter(function (child) { return child.permission.parentId == parent.id; }); // Filtrar os filhos
    children.forEach(d => childrenMenu.push(this.objToMenu(d.permission)));

    if (typeof children !== 'undefined' && children.length > 0) {
      if (tree.length == 0) {
        tree = childrenMenu;
      } else {
        parent.submenu = childrenMenu;
      }
      childrenMenu.forEach(child => {
        this.listToTree(array, child, tree);
      });
    }

    return tree;
  }

  objToMenu(obj) {
    return new SideMenu(
      {
        id: obj.id,
        path: obj.route,
        title: obj.title,
        moduleName: obj.moduleName,
        icon: obj.icon,
        class: obj.class,
        groupTitle: obj.groupTitle,
        submenu: []

      });
  }
}
